import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fa'); // Default to Persian
  const [direction, setDirection] = useState('rtl'); // Default to RTL for Persian

  useEffect(() => {
    // Load saved language from localStorage
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setLanguage(savedLanguage);
      setDirection(savedLanguage === 'fa' ? 'rtl' : 'ltr');
    }
    
    // Apply direction to document
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
  }, [direction, language]);

  const toggleLanguage = () => {
    const newLanguage = language === 'fa' ? 'en' : 'fa';
    const newDirection = newLanguage === 'fa' ? 'rtl' : 'ltr';
    
    setLanguage(newLanguage);
    setDirection(newDirection);
    
    // Save to localStorage
    localStorage.setItem('language', newLanguage);
    
    // Apply to document
    document.documentElement.dir = newDirection;
    document.documentElement.lang = newLanguage;
  };

  const value = {
    language,
    direction,
    toggleLanguage,
    isRTL: direction === 'rtl'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};